var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "应用", prop: "appid" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.formData.appid,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "appid", $$v)
                    },
                    expression: "formData.appid"
                  }
                },
                _vm._l(_vm.appListAllData, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.appid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c("div", { staticStyle: { width: "100%" } }),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "用户协议地址", prop: "user_agreement_url" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                on: {
                  input: function($event) {
                    return _vm.handleInput("user_agreement_content")
                  }
                },
                model: {
                  value: _vm.formData.user_agreement_url,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "user_agreement_url", $$v)
                  },
                  expression: "formData.user_agreement_url"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { label: "用户协议内容", prop: "user_agreement_content" }
            },
            [
              _c("Editor", {
                staticClass: "backgroundB",
                on: {
                  input: function($event) {
                    return _vm.handleInput("user_agreement_url")
                  }
                },
                model: {
                  value: _vm.formData.user_agreement_content,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "user_agreement_content", $$v)
                  },
                  expression: "formData.user_agreement_content"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "隐私协议地址", prop: "privacy_agreement_url" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                on: {
                  input: function($event) {
                    return _vm.handleInput("privacy_agreement_content")
                  }
                },
                model: {
                  value: _vm.formData.privacy_agreement_url,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "privacy_agreement_url", $$v)
                  },
                  expression: "formData.privacy_agreement_url"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: {
                label: "隐私协议内容",
                prop: "privacy_agreement_content"
              }
            },
            [
              _c("Editor", {
                staticClass: "backgroundB",
                on: {
                  input: function($event) {
                    return _vm.handleInput("privacy_agreement_url")
                  }
                },
                model: {
                  value: _vm.formData.privacy_agreement_content,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "privacy_agreement_content", $$v)
                  },
                  expression: "formData.privacy_agreement_content"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", round: "" },
              on: {
                click: function($event) {
                  return _vm.rewriteClearData(false)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }